import { forwardRef } from 'react'

import { IconButton, IconButtonProps } from '@enechain/ecloud-designsystem'
import { FaEllipsisRegular } from '@enechain/ecloud-icons'

export const MeatballsMenuAnchorElement = forwardRef<
  HTMLButtonElement,
  Omit<IconButtonProps, 'children'>
>(function MeatballsMenuAnchorElement(props, ref) {
  return (
    <IconButton
      {...props}
      ref={ref}
      backgroundColor="transparent"
      aria-label="Open Menu"
    >
      <FaEllipsisRegular />
    </IconButton>
  )
})
